import React, { Component } from 'react';
import Loading from '../../Loading';

class EtapaConteudo extends Component {
    // constructor(props) {
    //     super(props);
    //     this.state = {  }
    // }

    getUrlLivro(uri){
        return `${process.env.REACT_APP_LIVROS}${uri}`;
    }

    render() {
        return (<div className="conteudo-container">
        {this.props.loading && <Loading />}

        {!this.props.loading && <React.Fragment>
            <div className="edb-large edb-text-bold edb-margin-bottom">
                {this.props.estudoFinalizado && <span className="edb-margin-left"><i className="edb-xlarge adap-text-green far fa-check-circle" title="Estudo finalizado"></i></span>} {this.props.conteudo.txStudyMaterial}
            </div>
            {/* <div>{this.state.conteudo.txDescription}</div>
            <div>{this.state.conteudo.txUnitDescription}</div> */}

            {/* <iframe title="conteúdo" src="https://s3-sa-east-1.amazonaws.com/livros.edebe.com.br/e/b/d/mhi3_1_1_1_a.html"></iframe> */}
            <iframe title="conteúdo" src={this.getUrlLivro("/b.html")+"?r="+encodeURI(this.getUrlLivro(this.props.conteudo.txPath)+"&s="+document.cookie.replace(/(?:(?:^|.*;\s*)session\s*=\s*([^;]*).*$)|^.*$/, "$1"))}></iframe>
            {/* <iframe title="conteúdo" src={this.getUrlLivro(this.props.conteudo.txPath)}></iframe> */}

            {!this.props.fullScreen &&
                <button className="edb-button edb-round adap-dark-gray edb-display-bottomleft edb-margin-large-left edb-margin-large-bottom edb-hide-small"
                    onClick={() => this.props.onClickTelaInteira()} >
                    <i className="fas fa-expand edb-margin-small-right"></i>
                    Tela inteira
            </button>}

            {this.props.fullScreen &&
                <button className="edb-button edb-round adap-dark-gray edb-display-bottomleft edb-margin-large-left edb-margin-large-bottom edb-hide-small"
                    onClick={() => this.props.onClickSairTelaInteira()} >
                    <i className="fas fa-compress edb-margin-small-right"></i>
                    Sair da tela inteira
        </button>}
        </React.Fragment>}
    </div>);
    }
}

export default EtapaConteudo;